<form (ngSubmit)="onSendCommand()" [formGroup]="commandForm">
  <div class="container">
    <div class="command-content">
      @if (editCommandEnabled) {
        <div class="row">
          <div class="col-6 form-padding">
            <div class="form-group">
              <label for="username" translate>Username</label>
            </div>
          </div>
          <div class="col-6 form-padding">
            <div class="form-group">
              <input class="form-control"
                formControlName="username" id="username" name="username" type="text">
              </div>
            </div>
          </div>
        }
        @if (editCommandEnabled) {
          <div class="row">
            <div class="col-6 form-padding">
              <div class="form-group">
                <label for="password" translate>Password</label>
              </div>
            </div>
            <div class="col-6 form-padding">
              <div class="form-group">
                <input class="form-control"
                  formControlName="password" id="password" name="password" type="text">
                </div>
              </div>
            </div>
          }
          @for (signal of chartSettings?.signals; track signal) {
            <div class="mb-2">
              <div class="row justify-content-start align-items-center">
                <div class="col-6 form-padding">
                  <div class="form-group name">
                    <b [innerHTML]="getLabelAndUnit(signal)" [title]="getLabelAndUnit(signal)"
                    class="mr-2 name d-block"></b>
                  </div>
                </div>
                <div class="col-6 form-padding">
                  @if (!editCommandEnabled) {
                    <div>
                      <input class="value-input form-control"
                        [disabled]="!editCommandEnabled" [ngModel]="getValueOrFallback(signal)"
                        [ngModelOptions]="{standalone: true}" type="text">
                      </div>
                    } @else {
                      <form [formGroup]="signalsForm">
                        <div>
                          <input [ngClass]="{ 'is-invalid': f2[signal.signalName]?.errors }" class="value-input form-control"
                            [formControlName]="signal.signalName" [name]="signal.signalName" type="number" [placeholder]="minMaxValueString(signal)">
                            @if (f2[signal.signalName]?.touched && f2[signal.signalName]?.errors) {
                              <div class="invalid-feedback">
                                <span translate>The value has to be between the min and max values: {{minMaxValueString(signal)}}</span>
                              </div>
                            }
                          </div>
                        </form>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          @if (editCommandEnabled) {
            <div class="row justify-content-end content-buttons">
              <button [disabled]="isSendButtonDisabled" class="btn btn-primary" type="submit">
                <span translate>Send command</span>
                @if (isSendingCommand) {
                  <em class="fa-solid fa-spinner fa-spin"></em>
                }
              </button>
            </div>
          }
        </form>
